import {GenericFormContainer, Grid, IAlertData, setAlert, Leap4Breadcrumbs, Mode, MuiIcons, Toc as TocIcon} from "@leap4/frontend";
import {CreateAlertStore} from "./CreateAlertStore";
import {useHistory} from "react-router-dom";
import React, { useEffect, useMemo, useState} from "react";
import {IAlert} from "@leap4/entities-discrepancy-common";
import {ApiClient} from "../../../../../utils/apiClient";
import {urlService} from "../../../../routing/urlsService";
import {initialAlertObj} from "../base/Alert";
import {RootState} from "../../../../../store/store";
import {connect} from "react-redux";
import {DetailsForm} from "../base/DetailsForm";
import {AlertContext} from "../base/AlertContex";
import {AlertsBaseUrl} from "../../../../../config/generals";
import {Server} from "@leap4/auth";
import {OneOrgOnly} from "../../../../shared/OneOrgOnly/OneOrgOnly";

const {AddTask: AddTaskIcon} = MuiIcons;

export interface IAddAlertProps {
    setAlert: (data: IAlertData) => void;
}

let store: CreateAlertStore


const _addAlert = (props: IAddAlertProps) => {
    const history = useHistory();
    const [alert, setAlert] = useState<IAlert>(initialAlertObj);
    const [dataPoints, setDataPoints] = useState((initialAlertObj.params as any)?.relevantPlatforms || [])
    const alertContextValue = useMemo(() => ({alert,dataPoints, setDataPoints, setAlert}), [alert, dataPoints]);


    useEffect(() => {
        store = new CreateAlertStore({
            axiosClient: ApiClient,
            alertFunc: props.setAlert,
            baseUrl: `${AlertsBaseUrl}`
        })
    }, [])

    const onSubmit = async () => {
        await store.create(alert )
        history.push(urlService.alerts())
    };
    const lastChosenOrganization = localStorage.getItem(Server.headers.X_ORGANZIZATION).split('-')
    if (lastChosenOrganization.length > 1) {
        return <OneOrgOnly />
    }
    return (
        <>
            <Grid container>
                <Grid item xs={12}>
                    <Leap4Breadcrumbs breadcrumbs={[{
                        text: "Alerts Dashboard",
                        link: urlService.alerts(),
                        icon: <TocIcon/>
                    },
                        {
                            text: alert?.name ? alert.name : "New Alert",
                            icon: <AddTaskIcon/>
                        }]}
                    />
                </Grid>
                <Grid item xs={12}>
                    <GenericFormContainer mode={Mode.Create} onCreateOrEditFunc={onSubmit}>
                        <AlertContext.Provider value={alertContextValue}>
                            <DetailsForm mode={Mode.Create}/>
                        </AlertContext.Provider>
                    </GenericFormContainer>
                </Grid>
            </Grid>
        </>
    )
}

const mapStateToProps = (state: RootState) => ({});

export const AddAlert = connect(mapStateToProps, {
    setAlert: setAlert
})(_addAlert);
